import { Rive } from '@rive-app/canvas';

class Loader {
	constructor(el) {
		this.container = el;

		if (!this.container) return;

		this.canvas = this.container.querySelector('canvas');
		this.animationName = this.container.dataset.loader || 'loader';

		this.init();
	}

	init() {
		new Rive({
			src: `/assets/animations/${this.animationName}.riv`,
			canvas: this.canvas,
			autoplay: true,
			stateMachines: 'State Machine 1',
		});
	}
}

document.querySelectorAll('[data-loader]').forEach((el) => new Loader(el));
export default Loader;
